module.exports = __webpack_public_path__ + "static/media/document-add-black.e623912d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/document-add-black.svg
// module id = 1843
// module chunks = 0